import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        marginBottom: 12,
        alignSelf: 'center',
        alignItems: 'center',
        paddingHorizontal: 20,
        paddingVertical: 40,
        borderRadius: 8,
        borderColor: "#077A97",
        borderWidth: 0.5,
        shadowColor: "#000",
        shadowOffset: {
        width: 0,
        height: 4,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4.84,
        elevation: 4
    },

    txtContaBancaria: {
        textAlign: 'left',
        color: '#000000',
        fontSize: 28,
        flexDirection: 'row',
        marginTop: 40,
        marginLeft: 100,
        fontWeight: 'bold',
        },

        txtEditeSuaContaBancaria: {
        textAlign: 'left',
        color: '#000000',
        fontSize: 18,
        flexDirection: 'row',
        marginTop: 20,
        fontWeight: 'bold',
        marginLeft: 100,
    },

    titleCard: {
        fontWeight: 600,
        marginBottom: 20
    },

    contentBtn: {
        alignItems: 'center',
        marginTop: 20,
        paddingHorizontal: 20,
        width: 320,
    },
    btn: {
        padding: 10,
        width: 320,
        height: 48,
        padding: 14,
        borderRadius: 4,
        backgroundColor: '#077A97'
    },
    PickerSelect: {
        borderRadius: 4,
        paddingHorizontal: 10,
        height: 40,
        marginTop: 10,
        color: '#222'
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
